import * as R from "constants/userRights";
import { useEffect, useState } from "react";
import { useQueryWithErrorHandling } from "./errorHandling";
const { useApolloClient } = require("@apollo/client");
const { emptyObject, emptyArray } = require("constants/defaultValues");
const { USER_DATA } = require("features/common/queries");

const useUserData = () => {
  const client = useApolloClient();

  const { data } = useQueryWithErrorHandling(USER_DATA, { fetchPolicy: "cache-only" });
  const cacheUserData = data?.userData || {
    isInternalUser: false,
    showQuestionsInVCP: false,
    allowAutomatedDecision: false,
    isExchangeRateFunctionality: false,
    showDecisionReasons: false,
    dealerDrivenConsent: false,
    customerDrivenConsent: false,
    requestAlwaysConsent: false,
    allowSoleTraderSearch: false,
    allowInsurance: false,
    allowSelectionInsuranceConvention: false,
    useDownloadProductInStep4: false,
    rights: emptyArray,
    userRights: {
      hasUserRight: false,
      hasDealerAdminUserRight: false,
      hasAdminUserRight: false,
      hasEstimatorOnlyRight: false,
      hasVendorAdminUserRight: false,
    },
  };

  const [userData, setUserData] = useState(cacheUserData);

  useEffect(() => {
    const sub = client.watchQuery({ query: USER_DATA, fetchPolicy: "cache-only" }).subscribe({
      next: ({ data }) => {
        const userData = data?.userData || emptyObject;
        const userRights = {
          hasUserRight: Boolean(data?.userData?.user),
          hasAdminUserRight: Boolean(userData?.admin),
          hasDealerAdminUserRight: Boolean(userData?.dAdmin),
          hasVendorAdminUserRight: Boolean(userData?.vAdmin),
          hasEstimatorOnlyRight: Boolean(userData?.estimator),
        };
        const rights = [
          userRights.hasUserRight && R.userRights.user.code,
          userRights.hasAdminUserRight && R.userRights.adminUser.code,
          userRights.hasDealerAdminUserRight && R.userRights.dealerAdminUser.code,
          userRights.hasVendorAdminUserRight && R.userRights.vendorAdmin.code,
          userRights.hasEstimatorOnlyRight && R.userRights.estimatorOnly.code,
        ].filter(Boolean);

        setUserData({ ...userData, rights, userRights });
      },
    });
    return () => sub.unsubscribe();
  }, [client]);

  return userData;
};

export default useUserData;
